import { z } from "zod";

export const completeResponseSchema = z.object({
  token: z.string(),
});

export type CompleteResponse = z.infer<typeof completeResponseSchema>;
